import { _Right } from '@angular/cdk/scrolling';
import { Component, OnInit } from '@angular/core';
import { AppInitService } from '../../../digigov/services/app-init.service';

@Component({
  selector: 'app-dg-environment-details',
  templateUrl: './dg-environment-details.component.html',
  styleUrls: ['./dg-environment-details.component.scss'],
})
export class DgEnvironmentDetailsComponent implements OnInit {
  tooltip: any = 'below';
  EnvironmentDetails: {};
  urlval = {};
  constructor(public appInitService: AppInitService) {
    this.EnvironmentDetails = this.appInitService.appConfig;
  }

  baseval = this.appInitService.appConfig.baseUrl;
  environment = this.appInitService.appConfig.environment;
  ngOnInit(): void {
    this.urlval = Object.keys(this.EnvironmentDetails).map((key) => ({
      label: key,
      value: this.EnvironmentDetails[key],
    }));
  }
}
